import Tooltip from '@mui/material/Tooltip'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Paragraph from '../../../shared/UI/Paragraph'
import theme from '../../../theme/theme'
import { BookingHeaderColors } from './consts'

interface OccupancyDisplayProps {
  booked: number
  total: number
  percentage: number
}

export default function OccupancyDisplay({ booked, total, percentage }: OccupancyDisplayProps) {
  const isOverCapacity = booked > total

  return (
    <Paragraph
      size="13px"
      weight="medium"
      color={BookingHeaderColors.OCCUPANCY_TEXT}
      style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      {`Occupancy: ${booked}/${total}`}
      {isOverCapacity ? (
        <Tooltip title="The floorplan has likely changed since these bookings were made">
          <InfoOutlined
            sx={{
              color: theme.palette.primary.main,
              fontSize: '16px',
              verticalAlign: 'middle',
              marginLeft: '4px',
            }}
          />
        </Tooltip>
      ) : (
        ` (${percentage}% full)`
      )}
    </Paragraph>
  )
}
